import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfirmCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M44.3991 64C42.8025 64 41.5456 63.2281 40.4926 61.8947L33.155 52.9825C32.3057 51.9649 32 51.0877 32 50.0351C32 47.7193 33.8004 45.9298 36.0085 45.9298C37.2654 45.9298 38.2166 46.4561 39.0998 47.5439L44.3312 53.9298L56.3567 34.3509C57.3079 32.807 58.4289 32 59.8896 32C62.0637 32 64 33.6491 64 35.9298C64 36.807 63.6943 37.7544 63.0828 38.7018L48.1699 61.8246C47.2866 63.1579 45.8938 64 44.3991 64Z",
		fill: "#4E8B43"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 48,
		cy: 48,
		r: 47.5,
		stroke: "#232722",
		strokeOpacity: .1
	})]
});
export default SvgConfirmCheck;
